<template>
  <div>
    <!-- Loading... -->
  </div>
</template>
<script>
export default {
  name: "loading-page",
  data() {
    return {
      loader: null
    }
  },
  created() {
    this.loader = this.$loading.show({},{
      after: this.$createElement('div',{},[`Retrieving application data...`])
    });
  },
  beforeDestroy() {
    this.loader.hide();
    this.loader = null;
  }
}
</script>